import * as Styled from "./styles";
import { DatePickerFieldProps } from "./types";
import { useDatePickerField } from "./hooks";

const DatePickerField: React.FC<DatePickerFieldProps> = ({
  value,
  onChange,
  utc,
  disabled = false,
  ...props
}) => {
  const field = useDatePickerField({ value, onChange, utc, disabled });

  return <Styled.DatePicker {...props} {...field} disabled={disabled} />;
};

export default DatePickerField;
